<template>
  <section class="app-main">
    <div class="top-bar">
      <el-date-picker
        v-model="fixDate"
        @change="handleDate"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
        style="width: 240px; margin-right: 15px"
      ></el-date-picker>
      <el-input
        placeholder="输入订单号/条形码/手机号码/邮箱"
        v-model="searchVal"
        @change="search"
        style="width: 200px; margin-right: 25px"
      >
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
    </div>
    <el-card shadow="hover">
      <el-table
        :data="tableData"
        @selection-change="handleChecked"
        empty-text="暂无用户"
        height="560"
      >
        <el-table-column type="selection" width="100" align="center">
        </el-table-column>
        <el-table-column label="商品图片" align="center">
          <template slot-scope="scope">
            <m-img
              v-if="scope.row.goods_sku_pic_url"
              :src="scope.row.goods_sku_pic_url"
            />
          </template>
        </el-table-column>
        <el-table-column prop="title" label="订单号" align="center"  width="200" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="goods_name" label="商品名称" align="center"   width="190" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="sku_name" label="商品规格" align="center">
        </el-table-column>
        <el-table-column prop="barcode" label="商品条形码" align="center">
        </el-table-column>
        <el-table-column prop="number" label="销售数量" align="center">
        </el-table-column>
        <el-table-column prop="created_at" label="销售日期" align="center">
        </el-table-column>
        <el-table-column prop="price" label="销售金额" align="center">
        </el-table-column>
        <el-table-column prop="shops_title" label="所属店铺" align="center">
        </el-table-column>
        <el-table-column prop="tel" label="购买用户" align="center">
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="reloadData"
        layout="prev, pager, next, jumper"
        style="padding: 15px"
        :total="total"
        :page-size="size"
      ></el-pagination>
    </el-card>
  </section>
</template>


<script>
import { goods_sales_list } from "@/api/summary.js";
import MImg   from './../../../components/Image'
export default {
  name: "goodsSalesList",
  components: { MImg },
  data() {
    return {
      searchVal: "",
      tableData: [],
      page: 1,
      size: 20,
      total: 0,
      dialog: false, // 控制显示 添加修改弹窗
      ids: [], // table 选中数据的 id 数组集合
      fixDate: [],
    };
  },
  methods: {
    // 搜索会员
    search() {
      this.page = 1;
      this.handleData();
    },

    // 日期查询搜索
    handleDate() {
      this.page = 1;
      this.handleData();
    },
    // 获取数据
    handleData() {
      let params = {
        page: this.page,
      };
      if (this.searchVal != "") {
        params.search = this.searchVal;
      }

      if (this.fixDate && this.fixDate.length != 0) {
        params.start_date_search = this.fixDate[0];
        params.end_date_search = this.fixDate[1];
      }

      goods_sales_list(params)
        .then((res) => {
          if (res.code == 20000) {
            this.tableData = res.data.data;
            this.total = res.data.total;
            this.size = res.data.per_page;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    reloadData(page) {
      this.page = page;
      this.handleData();
    },
  },
  created() {
    this.handleData();
  },
  activated() {
    this.handleData();
  },
};
</script>

<style lang="less" scoped>
section {
  .top-btn {
    width: 100px;
    margin-right: 15px;
  }
  .line-item {
    margin-bottom: 20px;
  }
  .input-left {
    height: 40px;
    line-height: 40px;
  }
}
</style>